var $ = jQuery;

function noop() {}

function load(url,callback) {
	callback = callback || noop;
	var s = document.createElement("script");
	s.type = "text/javascript";
	s.async = true;
	s.src = url;
	s.onload = s.onreadystatechange = function(){
		if (!s.readyState || /loaded|complete/.test(s.readyState)) {
			s.onload = s.onreadystatechange = null;
			callback(null);
		}
	};
	var el = document.getElementsByTagName("head")[0] || document.documentElement;
	el.insertBefore(s,el.firstChild);
};

module.exports = function(opts,callback) {
	callback = callback || noop;
	
	var container = document.getElementById(opts.domElementId);
	var $container = $(container);
	
	var settings = $.extend(true,{
		playerVars:{
			version:3,
			enablejsapi:1,
			modestbranding:1,
			autoplay:1,
			rel:0,
			showinfo:0,
			color:'white',
			theme:'light',
			html5:1	
		}
	},opts);
	
	settings.videoId = '';
	if (settings.file) {
		settings.videoId = settings.file;
		delete settings.file;
	} else if (settings.playlist) {
		var _playlist = [];
		for (var i = 0, len = settings.playlist.length; i < len; ++i) {
			if (typeof settings.playlist[i] === "string") {
				_playlist.push(settings.playlist[i]);
			} else {
				_playlist.push(settings.playlist[i].sources[0].file);
			}
		}
		settings.videoId = _playlist.shift();
		settings.playerVars.playlist = _playlist;
		delete settings.playlist;
	}
	
	if (typeof settings.autostart !== "undefined") {
		settings.playerVars.autoplay = settings.autostart ? 1 : 0;
	}
	
	var onReadyCalled = false;
	
	var initialEvents = settings.events;
	delete settings.events;
	if (initialEvents.onReady) {
		settings.events = {
			onReady: function(){
				if (!onReadyCalled) {
					onReadyCalled = true;
					
					player.__state = null;
					player.__timeout = null;
					player.__playlistIndex = null;
					player.__callbacks = {
						onIdle:[],
						onPlay:[],
						onPause:[],
						onBuffer:[],
						onComplete:[],
						onTime:[],
						onPlaylistItem:[]
					};
					
					player.addEventListener('onStateChange',function(e){
						var state = player.getState();
						if (state !== player.__state) {
							switch (state) {
								case 'COMPLETE':
									for (var i = 0, len = player.__callbacks.onComplete.length; i < len; ++i) {
										player.__callbacks.onComplete[i].call(player);
									}
									break;
								case 'PLAYING':
									var playlistIndex = player.getPlaylistIndex();
									if (playlistIndex !== player.__playlistIndex) {
										for (var i = 0, len = player.__callbacks.onPlaylistItem.length; i < len; ++i) {
											player.__callbacks.onPlaylistItem[i].call(
												player,
												{index:playlistIndex,playlist:player.getPlaylist()}
											);
										}	
										player.__playlistIndex = playlistIndex;
									}
									for (var i = 0, len = player.__callbacks.onPlay.length; i < len; ++i) {
										player.__callbacks.onPlay[i].call(player,{oldstate:state});
									}
									break;
								case 'IDLE':
									for (var i = 0, len = player.__callbacks.onIdle.length; i < len; ++i) {
										player.__callbacks.onIdle[i].call(player,{oldstate:state});
									}
									break;
								case 'PAUSED':
									for (var i = 0, len = player.__callbacks.onPause.length; i < len; ++i) {
										player.__callbacks.onPause[i].call(player,{oldstate:state});
									}
									break;
								case 'BUFFERING':
									for (var i = 0, len = player.__callbacks.onBuffer.length; i < len; ++i) {
										player.__callbacks.onBuffer[i].call(player,{oldstate:state});
									}
									break;
							}
						}
						player.__state = state;
					});
					
					player.container = container;
					player.addButton = function(imgUrl,buttonTitle,onClick,id) {
						if (!player.__buttonContainer) {
							player.__buttonContainer = document.createElement("div");
							player.__buttonContainer.className = 'youtube-embed--button-container';
							player.__$buttonContainer = $(player.__buttonContainer);
							player.container.appendChild(player.__buttonContainer);
						}
						var $buttonEl = $("<div/>");
						$buttonEl
							.addClass('youtube-embed--button')
							.addClass('youtube-embed--button-' + id);
						if (buttonTitle) {
							var $buttonText = $("<span/>");
							$buttonText.text(buttonTitle);
							$buttonText.addClass("youtube-embed--button-text");
							$buttonEl.append($buttonText);
						}
						if (imgUrl) {
							var $img = $("<img/>");
							$img.attr("src",imgUrl);
							$img.addClass("youtube-embed--button-image");
							$buttonEl.append($img);
						}
						if (onClick) {
							player.__$buttonContainer.on(
								'mousedown.youtubeembed' + opts.domElementId,
								'.youtube-embed--button-' + id,
								function(e){
									e.preventDefault();
									onClick();
								}
							);
						}
						player.__$buttonContainer.append($buttonEl);
					};
					player.play = function(bool) {
						var state = player.getPlayerState();
						if (typeof bool === "undefined") {
							// toggle
							if (state === 1) { // playing
								player.stop();
							} else {
								player.playVideo();
							}
						} else {
							if (bool) {
								if (state !== 1) {
									player.playVideo();
								}
							} else {
								if (state === 1) {
									player.stopVideo();
								}
							}
						}
					};
					player.remove = function() {
						if (player.__$buttonContainer) {
							player.__$buttonContainer.off('mousedown.youtubeembed' + opts.domElementId);
							player.__$buttonContainer.remove();
							delete player.__$buttonContainer;
							delete player.__buttonContainer;
						}
						player.stopVideo();
						player.clearVideo();
						player.destroy();
					};
					player.setMute = function(bool) {
						if (typeof bool === "undefined") {
							// toggle
							if (player.isMuted()) {
								player.unMute();
							} else {
								player.mute();
							}
						} else {
							if (bool) {
								player.mute();
							} else {
								player.unMute();
							}
						}
					};
					player.stop = player.stopVideo;
					
					player.pause = function(bool) {
						var state = player.getPlayerState();
						if (typeof bool === "undefined") {
							if (state === 2) {// paused
								player.playVideo();
							} else {
								player.pauseVideo();
							}
						} else if (bool) {
							if (state !== 2) {
								player.pauseVideo();
							}
						} else {
							if (state === 2) {
								player.playVideo();
							}
						}
					};
					player.onIdle = function(cb) {
						player.__callbacks.onIdle.push(cb);
					};
					player.onPlay = function(cb) {
						player.__callbacks.onPlay.push(cb);
					};
					player.onError = function(cb) {
						player.addEventListener('onError',function(e){
							cb.call(player,e.data);
						});
					};
					player.onPause = function(cb) {
						player.__callbacks.onPause.push(cb);
					};
					player.onTime = function(cb) {
						player.__callbacks.onTime.push(cb);
						if (!player.__timeout) {
							player.__timeout = setInterval(function(){
								for (var i = 0, len = player.__callbacks.onTime.length; i < len; ++i) {
									player.__callbacks.onTime[i].call(
										player,
										{
											position:player.getCurrentTime(),
											duration:player.getDuration()
										}
									);
								}
							},500);
						}
					};
					// fired when playlist item completes
					player.onComplete = function(cb) {
						player.__callbacks.onComplete.push(cb);
					};
					player.onBuffer = function(cb) {
						player.__callbacks.onBuffer.push(cb);
					};
					player.onReady = function(cb) {
						player.addEventListener('onReady',function(){
							cb.call(player);
						});
					};
					player.onPlaylistItem = function(cb) {
						player.__callbacks.onPlaylistItem.push(cb);
					};
					player.getState = function() {
						var state = player.getPlayerState();
						switch (state) {
							case YT.PlayerState.ENDED:
								return 'COMPLETE';
							case YT.PlayerState.PLAYING:
								return 'PLAYING';
							case YT.PlayerState.CUED:
							case -1: // unstarted
								return 'IDLE';
							case YT.PlayerState.PAUSED:
								return 'PAUSED';
							case YT.PlayerState.BUFFERING:
								return 'BUFFERING';
							default:
								return state;
						}
					};
					player.getPosition = player.getCurrentTime;
					/*
					 * A 'setVolume' method with the right signature is already defined.
					player.setVolume = function(volume) {
						
					};
					*/
					player.seek = player.seekTo;

					/*
					 * A 'getDuration' method with the right signature already exists.
					player.getDuration = function() {
						
					};
					*/
					player.load = function(playlist) {
						delete player.__playlistIndex;
						player.loadPlaylist(playlist);
					};
					
					var oldGetPlaylist = player.getPlaylist;
					
					player.getPlaylist = function() {
						return oldGetPlaylist.call(player) || [settings.videoId];
					};
					
					var oldGetPlaylistIndex = player.getPlaylistIndex;
					
					player.getPlaylistIndex = function() {
						var idx = oldGetPlaylistIndex.call(player);
						if ((typeof idx !== "number") || (idx < 0)) {
							idx = 0;
						}
						return idx;
					};
					
					player.playlistItem = player.playVideoAt;
					
					initialEvents.onReady.call(player);
					delete initialEvents.onReady;
					
					for (var event in initialEvents) {
						if (initialEvents.hasOwnProperty(event)) {
							player[event](initialEvents[event]);
						}
					}
					
					callback(null,player);
				}
			}
		};
	}
	
	var el = document.createElement('div');
	el.setAttribute('id', opts.domElementId + "--iframe");
	
	container.appendChild(el);
	
	var player;
	window.onYouTubeIframeAPIReady = function() {
		player = new window.YT.Player(opts.domElementId + "--iframe",settings);
	};
	
	load("https://www.youtube.com/iframe_api");
	
	callback(null,player);
};